// Section 22 title screen "How to play": a short in-game guide (text in ui/text/en.ts).
import { uiText } from '../text/en';
import './settings.css';

export function HowToPlay({ onClose }: { onClose: () => void }) {
  const t = uiText.howToPlay;
  return (
    <article class="howto">
      <header class="overlay__head">
        <h2 id="howto-title">{t.title}</h2>
        <button type="button" class="button button--small" onClick={onClose}>
          {t.close}
        </button>
      </header>
      {t.sections.map((s) => (
        <section key={s.heading}>
          <h3>{s.heading}</h3>
          <p class="prose">{s.body}</p>
        </section>
      ))}
    </article>
  );
}
